import { aggFuncForFeesBreakdown } from "features/fees/posted/PostedFeeChargeUtils";
import {
  useFeeChargeEventRetrieveSuspense,
  useFeePeriodOffsetsTrueUpBreakdownRetrieveSuspense,
  useFeePeriodTrueUpBreakdownRetrieveSuspense,
} from "gen/endpoints/fee-charge-event/fee-charge-event";
import { FundFamilyEventTypeEnum } from "gen/model/fundFamilyEventTypeEnum";
import { useTranslation } from "react-i18next";
import PageBody from "shared/components/layout/PageBody";
import PageContent from "shared/components/layout/PageContent";
import { PageHeader } from "shared/components/layout/PageHeader";
import { TableBox } from "shared/components/table/box/TableBox";
import { TableBoxBody } from "shared/components/table/box/TableBoxBody";
import { TableBoxHeader } from "shared/components/table/box/TableBoxHeader";
import { TableBoxTitle } from "shared/components/table/box/TableBoxTitle";
import { DataTable } from "shared/components/table/data/DataTable";
import { DataTableBoxActions } from "shared/components/table/data/DataTableBoxActions";
import { useRequiredStringParams } from "shared/hooks/useRequiredStringParams";
import { rootRoute } from "shared/navigation/Routes";

export const FeePeriodCancelCorrectFeeAdjustmentsBreakdownPage: React.FC =
  () => {
    const { t } = useTranslation(["fees"]);
    const { fundFamilyId, feeChargeEventId } = useRequiredStringParams();

    const { data: feeChargeEvent } = useFeeChargeEventRetrieveSuspense(
      fundFamilyId,
      feeChargeEventId,
    );

    const { data: catchUpBreakdownTableData } =
      useFeePeriodTrueUpBreakdownRetrieveSuspense(
        fundFamilyId,
        feeChargeEventId,
        {
          posted_fund_family_event_type: FundFamilyEventTypeEnum.cancel_correct,
        },
      );
    const { data: catchUpOffsetsBreakdownTableData } =
      useFeePeriodOffsetsTrueUpBreakdownRetrieveSuspense(
        fundFamilyId,
        feeChargeEventId,
        {
          posted_fund_family_event_type: FundFamilyEventTypeEnum.cancel_correct,
        },
      );

    const isFullWidth = true;

    return (
      <PageContent>
        <PageHeader
          title={t("fees:cancelCorrectFeeAdjustments")}
          backButton={{
            title: t("feePostingWithPeriod", {
              period: feeChargeEvent.fee_charge_daterange_rich_name,
            }),
            path: rootRoute({})
              .fundFamilies({})
              .fundFamily({ fundFamilyId })
              .fees({})
              .feeChargeEventPosted({ feeChargeEventId }).$,
          }}
        />
        <PageBody>
          <TableBox isFullWidth={isFullWidth}>
            <TableBoxHeader>
              <TableBoxTitle>
                {t("fees:trueUpPages.cancelCorrectFeeAdjustmentsBreakdown")}
              </TableBoxTitle>
              <DataTableBoxActions />
            </TableBoxHeader>
            <TableBoxBody>
              <DataTable
                data={catchUpBreakdownTableData}
                aggFunc={aggFuncForFeesBreakdown}
              />
            </TableBoxBody>
          </TableBox>
          <TableBox isFullWidth={isFullWidth}>
            <TableBoxHeader>
              <TableBoxTitle>
                {t("fees:trueUpPages.equalizedOffsets")}
              </TableBoxTitle>
              <DataTableBoxActions />
            </TableBoxHeader>
            <TableBoxBody>
              <DataTable data={catchUpOffsetsBreakdownTableData} />
            </TableBoxBody>
          </TableBox>
        </PageBody>
      </PageContent>
    );
  };
